import { render, staticRenderFns } from "./Leaders.vue?vue&type=template&id=cd8452a8&scoped=true&"
import script from "./Leaders.vue?vue&type=script&lang=js&"
export * from "./Leaders.vue?vue&type=script&lang=js&"
import style0 from "./Leaders.vue?vue&type=style&index=0&id=cd8452a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8452a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VLayout,VRow})
